import { useCallback, useEffect, useMemo } from "react"
import { useUnit } from "effector-react"

import { $exchangeRates, fetchExchangeRates } from "stores/exchangeRates"
import { getExchangeRateID, IGetExchangeRateRequest } from "models/ExchangeRate"
import useTenantCurrency from "./useTenantCurrency"

interface IUseExchangeRatesParams {
    items?: IGetExchangeRateRequest[]
}

export default function useExchangeRates({
    items = [],
}: IUseExchangeRatesParams = {}) {
    const exchangeRates = useUnit($exchangeRates)
    const tenantCurrency = useTenantCurrency()

    const exchangeRatesParams: IGetExchangeRateRequest[] | null = useMemo(() => {
        if (!items.length || !tenantCurrency) return null
        return items.filter(item => {
            return item.currency !== tenantCurrency
        })
    }, [items, tenantCurrency])

    useEffect(() => {
        if (!exchangeRatesParams) return
        fetchExchangeRates(exchangeRatesParams)
    }, [exchangeRatesParams])

    const getExchangeRate = useCallback((params: IGetExchangeRateRequest): number | null => {
        if (!tenantCurrency || tenantCurrency === params.currency) return null
        return exchangeRates.get(getExchangeRateID(params))?.conversionRate ?? null
    }, [exchangeRates, tenantCurrency])

    return {
        getExchangeRate,
    }
}
